module.exports = __webpack_public_path__ + "static/online_friends-21a61aed056fa3d31cd51ba95ba9f976.svg";